import type { Anchor } from "../types/template";

export interface Rect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export function resolveAnchorOrigin(
  anchor: Anchor,
  drawable: Rect,
  widthMm: number,
  heightMm: number,
): { x: number; y: number } {
  const xCenter = drawable.x + (drawable.width - widthMm) / 2;
  const yCenter = drawable.y + (drawable.height - heightMm) / 2;
  const xRight = drawable.x + drawable.width - widthMm;
  const yBottom = drawable.y + drawable.height - heightMm;

  switch (anchor) {
    case "top-left":
      return { x: drawable.x, y: drawable.y };
    case "top-center":
      return { x: xCenter, y: drawable.y };
    case "top-right":
      return { x: xRight, y: drawable.y };
    case "middle-left":
      return { x: drawable.x, y: yCenter };
    case "middle-center":
      return { x: xCenter, y: yCenter };
    case "middle-right":
      return { x: xRight, y: yCenter };
    case "bottom-left":
      return { x: drawable.x, y: yBottom };
    case "bottom-center":
      return { x: xCenter, y: yBottom };
    case "bottom-right":
      return { x: xRight, y: yBottom };
    default:
      return anchor satisfies never;
  }
}
